import styled from 'styled-components'
import Loader from '../../Loader/Loader'

const LoaderContainer = styled.div`
  height: calc(100vh - 132px);
  background: white;
  position: fixed;
  top: 32px;
  left: 0;
  width: 100%;

  h3 {
    position: absolute;
    top: 33%;
    left: 50%;
    transform: translateX(-50%);
  }
`

const PrintDownloadLoaderView = () => {
  return (
    <LoaderContainer>
      <h3>Preparing document...</h3>
      <Loader />
    </LoaderContainer>
  )
}

export default PrintDownloadLoaderView
